import { ResourceSkill } from "./resource-skill";
import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("skills")
export class Skill extends BaseEntity {
  description: string;
  resourceList: ResourceSkill[];
}

@HateoasProjection(Skill, "basic")
export class SkillBasicProjection extends BaseEntity {
  description: string;
}
